!function(ThemeColor,LoaderManager){window.EnvironmentVariable=class{static get themeColors(){return ThemeColor}static isGlobalLoadersEnabled(){return LoaderManager.isEnabled()}}}(window.ThemeColor,window.LoaderManager);
//# sourceMappingURL=environment_variable.class.es6.js.map
;
